import "../styles/BackgroundBlurStyle.css";

export default function BackgroundBlur() {
  return (
    <div className="background-blur-wrapper">
      <div className="blur-circle pink"></div>
      <div className="blur-circle purple"></div>
    </div>
  );
}
